module.exports = __webpack_public_path__ + "img/gg-authen.cd7f3ce8.png";